<template lang="pug">
.editor
  v-content
    router-view
</template>

<script>
  export default {
    data () {
      return {}
    }
  }
</script>

<style scoped lang="scss">
.container {
  padding: 0;
}
.full .toolbar {
  z-index: 999;
}

</style>



// WEBPACK FOOTER //
// src/components/Layouts/Editor.vue